var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "element-value",
          rawName: "v-element-value",
          value: _vm.value,
          expression: "value",
        },
      ],
      staticClass: "text-input",
    },
    [
      _c(
        "textarea",
        _vm._g(
          _vm._b(
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.proxyValue,
                  expression: "proxyValue",
                },
                { name: "autosize", rawName: "v-autosize" },
              ],
              domProps: { value: _vm.proxyValue },
              on: {
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.proxyValue = $event.target.value
                },
              },
            },
            "textarea",
            _vm.proxyAttrs,
            false
          ),
          _vm.$listeners
        )
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }